<template>
  <v-container max-width="800px">
    <h2 class="mb-4">Edit Welcome Email Template</h2>
    <v-alert v-if="status" type="success" prominent class="mb-3">{{ status }}</v-alert>
    <v-alert v-if="error" type="error" prominent class="mb-3">{{ error }}</v-alert>
    <v-form @submit.prevent="saveTemplate">
      <v-textarea
        v-model="editorContent"
        label="Template Content"
        rows="20"
        :disabled="loading"
        outlined
        auto-grow
        class="mb-4"
        style="font-family:monospace;"
      ></v-textarea>
      <div class="mt-2">
        <v-btn color="primary" type="submit" :loading="loading" class="mr-2">Save Changes</v-btn>
        <v-btn color="warning" @click="restoreBackup" :loading="loading">Restore from Backup</v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
// CKEditor imports removed
import { Inertia } from '@inertiajs/inertia';
// No Ziggy import needed
import Layout from '@/Shared/VuetifyAdminLayout';
export default {
    layout: Layout,
  props: {
      content: String,
      status: String,
      error: String,
      baseUrl: {
        type: String,
        required: true
      }
  },
  data() {
    return {
      editorContent: this.content,
      
      loading: false,
    // editorConfig removed
      bladePattern: /{{[^}]+}}|\$[a-zA-Z_][a-zA-Z0-9_]*|@php[\s\S]*?@endphp/g,
    };
  },
  methods: {
    baseUrl() {
            return this.baseUrl; // Use the prop instead of the method
    },
    saveTemplate() {
      this.loading = true;
      // Check for Blade variable corruption
      const originalVars = this.content.match(this.bladePattern) || [];
      const newVars = this.editorContent.match(this.bladePattern) || [];
      if (originalVars.some(v => !newVars.includes(v))) {
        alert('You cannot remove Blade variables like $image or {{ ... }}.');
        this.loading = false;
        return;
      }
            Inertia.post(`${this.baseUrl}/admin/email-template/update`, { content: this.editorContent }, {
        onFinish: () => { this.loading = false; }
      });
    },
    restoreBackup() {
      this.loading = true;
            Inertia.post(`${this.baseUrl}/admin/email-template/restore`, {}, {
        onFinish: () => { this.loading = false; }
      });
    }
  }
};
</script>

